module.exports = __webpack_public_path__ + "img/btn_setting.dbba8d97.png";